import {
    GET_POST_REQUEST,
    GET_POST_SUCCESS,
    GET_POST_FAILURE,
} from '../constant/actionTypes';

const initState = {
    sender: "",
    senderIcon: "",
    lastUpdate: "",
    title: "",
    body: "",
    imgUrls: [],
    likeCount: 0,
    commentCount: 0,
    pid: "",
    isLoading: true,
    pageNotFound: false,
}

const social = (state = initState, action) => {
    switch (action.type) {
        case GET_POST_SUCCESS:
            return {
                ...state,
                sender: action.payload.sender.nickname,
                senderIcon: action.payload.sender.imgUrl,
                lastUpdate: action.payload.lastUpdate,
                title: action.payload.title,
                body: action.payload.body.replace(/\n/g, "<br>"),
                imgUrls: action.payload.imgUrls,
                likeCount: action.payload.likeCount,
                commentCount: action.payload.commentCount,
                pid: action.payload.pid,
                isLoading: false,
            }        
        case GET_POST_FAILURE:
            return {
                ...state,
                pageNotFound: true,
            }
        case GET_POST_REQUEST:
        default:
            return {
                ...state,
            }
    }
};

export default social;